// extracted by mini-css-extract-plugin
export default {"label":"Questions_label__ovNju","hint":"Questions_hint__g-qgR","checkboxList":"Questions_checkboxList__DjLBB","skeletonLoadingAnimation":"Questions_skeletonLoadingAnimation__sIBSe"};